<template>
  <div id="letter-index">
    <b-card class="mb-5">
      <b-row class="mb-2">
        <b-col md="10">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">{{ $t('dashboard') }}</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-col md="2 mt-4"> </b-col>
      </b-row>
      <form v-on:submit.prevent="doFilter">
        <b-row class="mt-2 mb-1">
          <!-- <b-col md="3 mb-1">
              <b-form-select v-model="tableFilter.parent" :options="parentList" />
          </b-col> -->
          <b-col md="3 mb-1">
            <b-form-input :placeholder="$t('letterType')" v-model="tableFilter.search" />
          </b-col>
          <b-col md="3 mb-1">
            <date-picker
              v-model="tableFilter.date"
              type="date"
              :placeholder="$t('letterDate')"
            ></date-picker>
          </b-col>
          <b-col class="pl-2">
            <button
              type="button"
              @click="exportLetter()"
              class="btn btn-success btn-sm"
              v-b-tooltip.hover
              title="Unduh laporan harian"
            >
              <b-spinner small label="Loading..." v-if="loading"></b-spinner>
              <b-icon icon="download" v-else></b-icon>
            </button>
            <button
              type="button"
              class="btn btn-success btn-sm ml-2"
              v-b-tooltip.hover
              title="Unduh laporan bulanan"
              v-b-toggle.collapse-1
              variant="success"
            >
              <b-icon icon="cloud-download"></b-icon>
            </button>
            <b-collapse id="collapse-1" class="mb-2">
              <p>Masukkan bulan & tahun</p>
              <input class="form-control w-50" type="month" v-model="tableFilter.month" id="" />
              <button
                @click="exportMounthly()"
                type="button"
                size="sm"
                class="mt-2 btn btn-sm btn-primary"
              >
                <b-spinner small label="Loading..." v-if="loading2"></b-spinner>
                <span v-else>
                  Unduh
                </span>
              </button>
            </b-collapse>
          </b-col>
          <b-col md="3 mb-1">
            <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search">
              <font-awesome-icon icon="search" /> {{ $t('filter') }}
            </button>
            <button
              @click="clearFilter()"
              class="ml-0 btn btn-outline-primary float-right"
              id="btn-search"
            >
              <font-awesome-icon icon="times-circle" /> {{ $t('clear') }}
            </button>
          </b-col>
        </b-row>
      </form>
      <b-row> </b-row>
      <paginated-table
        ref="dataTable"
        :can-approve="false"
        :can-reject="false"
        :can-paid="false"
        :can-delete="false"
        :can-edit="false"
        :data-url="apiUrl.letter"
        :data-key="dataKey"
        :data-columns="columns"
        :data-params="['search', 'letter_date']"
      >
      </paginated-table>
    </b-card>
  </div>
</template>
<script>
import PaginatedTable from '../../components/PaginatedTable.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import axios from 'axios';
export default {
  components: { PaginatedTable, DatePicker },
  data() {
    return {
      dataKey: 'letter_of_assignment',
      apiUrl: {
        letter: window.AppConfig.apiUrl + 'letter-of-assignment',
        exportDailyLetter:
          window.AppConfig.apiUrl + 'export-letter-assignment-daily-report-pdf?token=',
        exportMonthlyLetter:
          window.AppConfig.apiUrl + 'export-letter-assignment-monthly-report-pdf?token=',
      },
      accessToken: this.$store.getters['account/tokens'].access_token,
      loading: false,
      loading2: false,
      tableFilter: {
        letter_date: this.$route.query.date,
        search: this.$route.query.letterType,
        date: null,
        letterType: null,
        month: null,
      },
      columns: [
        {
          key: 'letterNumber',
          label: this.$root.$t('letterNumber'),
          sortable: true,
        },
        {
          key: 'letterDate',
          label: this.$root.$t('letterDate'),
          sortable: true,
        },
        {
          key: 'letterOfAssignmentType.name',
          label: this.$root.$t('letterType'),
          sortable: true,
        },
        {
          key: 'letterPurpose',
          label: this.$root.$t('letterPurpose'),
          sortable: true,
        },
        {
          key: 'letterStartDate',
          label: this.$root.$t('letterStartDate'),
          sortable: true,
        },
        {
          key: 'letterEndDate',
          label: this.$root.$t('letterEndDate'),
          sortable: true,
        },
        {
          key: 'actions',
          label: '',
          sortable: true,
        },
      ],
    };
  },

  methods: {
    doFilter() {
      this.tableFilter.search = this.tableFilter.search;
      this.tableFilter.letter_date =
        this.tableFilter.date !== null
          ? this.$moment(this.tableFilter.date).format('YYYY-MM-DD')
          : null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },

    clearFilter() {
      (this.tableFilter.search = null), (this.tableFilter.date = null);
    },

    exportLetter() {
      // this.loading = true;
      let url =
        this.apiUrl.exportDailyLetter +
        this.accessToken +
        '&date=' +
        this.$moment(this.tableFilter.date).format('YYYY-MM-DD');
      window.open(url);
    },

    exportMounthly() {
      let url =
        this.apiUrl.exportMonthlyLetter + this.accessToken + '&month=' + this.tableFilter.month;
      window.open(url);
    },
  },
};
</script>
<style></style>
